import generalController from "../generalController";
import errorLang from "./shared/error";
import formLang from "./shared/form";
import globalLang from "./shared/global";
import global from "./shared/global";

export const languageController = (function () {
  const langCode = generalController.detectLanguage();

  const data = {
    kmi: {
      heading: {
        en: 'Keep Me Informed',
        fr: 'Tenez-moi au courant'
      },
      subHeading: {
        en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc posuere,velit sit amet aliquam ultricies.',
        fr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc posuere,velit sit amet aliquam ultricies. (FR)',
      },
      submit: {
        en: 'Sign me up',
        fr: 'Sign me up (FR)',
      },
      subscribeLegal: {
        en: global.subscribeLegal.en,
        fr: global.subscribeLegal.fr
      },
      confirmationHeading: {
        en: 'You’re signed up',
        fr: 'You’re signed up (FR)',
      },
      confirmationSubHeading: {
        en: 'Stay tuned for email communications from us.',
        fr: 'Stay tuned for email communications from us. (FR)',
      },
      confirmationSubmit: {
        en: 'Sign up another email',
        fr: 'Sign up another email (FR)'
      }
    },
    contact: {
      submit: {
        en: 'Submit Inquiry',
        fr: 'Submit Inquiry (FR)',
      },
    },
    findDealer: {
      mobileMap: {
        en: 'Map view',
        fr: 'Map view (FR)'
      },
      mobileList: {
        en: 'List view',
        fr: 'List view (FR)'
      },
      searchInput: {
        en: 'City, Postal Code or Dealer',
        fr: 'City, Postal Code or Dealer (FR)',
      },
      searchSubmit: {
        en: 'Search',
        fr: 'Search (FR)',
      },
      useGeolocation: {
        en: 'Use my current location',
        fr: 'Use my current location (FR)',
      },
      searching: {
        en: 'Searching',
        fr: 'recherche',
      },
      geoLoading: {
        en: 'Retrieving Geolocation',
        fr: 'Géolocalisaton en cours'
      },
      geoDenied: {
        en: 'Permission denied. Please enable location detection.',
        fr: 'Autorisation refusée. Veuillez activer la localisation.'
      },
      geoUnavailable: {
        en: 'Can not detect position. Please try postal code instead.',
        fr: 'Impossible de détecter votre position. Veuillez essayer en indiquant un code postal.'
      },
      geoTimeout: {
        en: 'Detection timed out. Please try again.',
        fr: 'La détection a été interrompue. Veuillez réessayer.'
      },
      errorNoResults: {
        en: 'No results found, Please try again',
        fr: 'Aucun résultat, veuillez essayer de nouveau'
      },
      availableServices: {
        en: 'Available Services',
        fr: 'Available Services (FR)',
      },
      serviceEV: {
        en: 'Electric Vehicle Dealer',
        fr: 'Concessionnaire de VÉ',
      },
      serviceCreditApplication: {
        en: 'Credit Application',
        fr: 'Credit Application (FR)',
      },
      serviceLiveChat: {
        en: 'Live Chat',
        fr: 'Live Chat (FR)',
      },
      serviceTradeIn: {
        en: 'Trade-in Tool',
        fr: 'Trade-in Tool (FR)',
      },
      serviceSMS: {
        en: 'SMS',
        fr: 'SMS',
      },
      serviceOnlinePurchasing: {
        en: 'Online Purchasing',
        fr: 'Online Purchasing (FR)',
      },
      hoursSales: {
        en: 'Sales Hours',
        fr: 'Sales Hours (FR)',
      },
      hoursParts: {
        en: 'Parts Hours',
        fr: 'Parts Hours (FR)',
      },
      hoursService: {
        en: 'Service Hours',
        fr: 'Service Hours (FR)',
      },
      bookServiceCta: {
        en: 'Book a Service Appointment',
        fr: 'Book a Service Appointment (FR)',
      },
      bookTestDriveCta: {
        en: 'Book a test drive',
        fr: 'RÉSERVER UN ESSAI ROUTIER',
      },
      GetQuoteCta: {
        en: 'Get a quote',
        fr: 'Get a quote (FR)',
      },
      or: {
        en: globalLang.or.en,
        fr: globalLang.or.fr,
      },
      closed: {
        en: 'Closed',
        fr: 'Fermé'
      },
      sendBuildToDealer: {
        en: 'Send build to this dealer',
        fr: 'Send build to this dealer (FR)'
      },
      // beforeOpen: {
      //   en: 'Closed. Opens at',
      //   fr: 'Closed. Opens at (FR)',
      // },
      // openUntil: {
      //   en: 'Open now until',
      //   fr: 'Open now until (FR)',
      // },
      // afterOpen: {
      //   en: 'Closed. Opens tomorrow at',
      //   fr: 'Closed. Opens tomorrow at (FR)',
      // },
      // nextOpenday: {
      //   en: 'Closed. Opens on',
      //   fr: 'Closed. Opens on (FR)',
      // },
    },
    testDrive: {
      step1Title: {
        en: 'Book a test drive',
        fr: 'Book a test drive (FR)'
      },
      step2Subtitle: {
        en: 'Please select a date and time of day you’d like to test drive a Mazda vehicle.',
        fr: 'Please select a date and time of day you’d like to test drive a Mazda vehicle. (FR)'
      },
      step4Submit: {
        en: 'Book test drive',
        fr: 'Book test drive (FR)'
      },
    },
    getQuote: {
      step1Title: {
        en: 'Get a Quote',
        fr: 'Get a Quote (FR)'
      },
      step2Submit: {
        en: 'Get your quote',
        fr: 'Get your quote (FR)'
      },
    },
    confirmationStep: {
      title: {
        en: 'Thank you for your request',
        fr: 'Thank you for your request (FR)',
      },
      subTitle: {
        en: 'Your dealer will contact you shortly.',
        fr: 'Your dealer will contact you shortly. (FR)',
      },
    },
    tradeInEstimator: {
      // Step navs
      step1: {
        en: 'Current vehicle',
        fr: 'Current vehicle (FR)',
      },
      step2: {
        en: 'Desired Mazda',
        fr: 'Desired Mazda (FR)',
      },
      step3: {
        en: 'Your information',
        fr: 'Your information (FR)',
      },
      step4: {
        en: 'Dealer',
        fr: 'Dealer (FR)',
      },
      // Step 1
      step1Title: {
        en: 'Select your current vehicle',
        fr: 'Select your current vehicle (FR)',
      },
      step1SubTitle: {
        en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dignissim eros et accumsan condimentum. Donec lobortis in mauris id iaculis.',
        fr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dignissim eros et accumsan condimentum. Donec lobortis in mauris id iaculis. (FR)',
      },
      step1Disclaimer: {
        en: 'The value of your vehicle is influenced by the odometer reading, its equipment, and most importantly, the condition of the vehicle. The values presented here may be higher or lower after your vehicle has been evaluated by a professional vehicle appraiser.',
        fr: 'The value of your vehicle is influenced by the odometer reading, its equipment, and most importantly, the condition of the vehicle. The values presented here may be higher or lower after your vehicle has been evaluated by a professional vehicle appraiser. (FR)',
      },
      // Step 2
      step2Title: {
        en: 'Select the Mazda vehicle you are considering',
        fr: 'Select the Mazda vehicle you are considering (FR)',
      },
      // Step 3
      step3Title: {
        en: 'Please fill out your information',
        fr: 'Please fill out your information (FR)',
      },
      // Step 4
      step4Title: {
        en: 'Find your closest dealer',
        fr: 'Find your closest dealer (FR)',
      },
      step4Submit: {
        en: 'Get your trade in estimate',
        fr: 'Get your trade in estimate (FR)',
      },
      // Ste; 5
      step5Title: {
        en: 'Your vehicle value estimate',
        fr: 'Your vehicle value estimate (FR)',
      },
      step5Title2: {
        en: 'You are interested in',
        fr: 'You are interested in (FR)',
      },
      step5EstimateCopy1: {
        en: 'Based on your current vehicle',
        fr: 'Based on your current vehicle (FR)',
      },
      step5EditDetails: {
        en: 'Edit Details',
        fr: 'Edit Details (FR)',
      },
    },
    bookServiceAppointment: {
      // Step navs
      step1: {
        en: 'Vehicle info',
        fr: 'Vehicle info (FR)',
      },
      step2: {
        en: 'Service Details',
        fr: 'Service Details (FR)',
      },
      step3: {
        en: 'Select a dealer',
        fr: 'Select a dealer (FR)',
      },
      step4: {
        en: 'Date and time',
        fr: 'Date and time (FR)',
      },
      step5: {
        en: 'Contact details',
        fr: 'Contact details (FR)',
      },
      // Step 2
      step2Title: {
        en: 'Service Details',
        fr: 'Service Details (FR)',
      },
      step2SubTitle: {
        en: 'What service(s) do you need on your vehicle.',
        fr: 'What service(s) do you need on your vehicle. (FR)',
      },
      // Step 3
      step3Title: {
        en: 'Find your closest dealer',
        fr: 'Find your closest dealer (FR)',
      },
      // Step 4
      step4SubTitle: {
        en: 'Please select a date and time of day you’d like to book your vehicle service.',
        fr: 'Please select a date and time of day you’d like to book your vehicle service. (FR)',
      },
      // Step 5
      step5Submit: {
        en: 'Book service appointment',
        fr: 'Book service appointment',
      }
    },
    evRangeMap: {
      searchCTA: {
        en: 'Show range',
        fr: 'Show range',
      },
      showRangeLoading: {
        en: 'Loading', // tmp
        fr: 'Loading (FR)', // tmp
      },
    },
    saveBuild: {
      heading: {
        en: 'Save your build',
        fr: 'Save your build (FR)'
      },
      subHeading: {
        en: 'Save time and conveniently save your ideal Mazda now for future reference.',
        fr: 'Save time and conveniently save your ideal Mazda now for future reference. (FR)',
      },
      submit: {
        en: 'Save my build',
        fr: 'Save my build (fr)',
      },
      confirmationHeading: {
        en: 'Your build is saved',
        fr: 'Your build is saved (FR)',
      },
      confirmationSubHeading: {
        en: 'We emailed you a link so you can review this build later lorem ipsum.',
        fr: 'We emailed you a link so you can review this build later lorem ipsum. (FR)',
      },
      confirmationSubmit: {
        en: 'Close this window',
        fr: 'Close this window (FR)'
      }
    },
    shareBuild: {
      heading: {
        en: 'Share your build',
        fr: 'Share your build (FR)'
      },
      subHeading: {
        en: 'Send the URL of your Mazda build via email or SMS.',
        fr: 'Send the URL of your Mazda build via email or SMS. (FR)',
      },
      submit: {
        en: 'Share my build',
        fr: 'Share my build (fr)',
      },
      confirmationHeading: {
        en: 'Lorem Ipsum',
        fr: 'Lorem Ipsum (FR)',
      },
      confirmationSubHeading: {
        en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        fr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. (FR)',
      },
      confirmationSubmit: {
        en: 'Close this window',
        fr: 'Close this window (FR)'
      },
      byEmail: {
        en: 'By Email',
        fr: 'By Email (FR)'
      },
      bySMS: {
        en: 'By SMS',
        fr: 'By SMS (FR)'
      },
    },
    sendBuildToDealer: {
      heading: {
        en: 'Send Build To Dealer',
        fr: 'Send Build To Dealer (FR)'
      },
      subHeading: {
        en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        fr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. (FR)',
      },
      submit: {
        en: 'Submit',
        fr: 'Submit (fr)',
      },
      confirmationHeading: {
        en: 'Lorem Ipsum',
        fr: 'Lorem Ipsum (FR)',
      },
      confirmationSubHeading: {
        en: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        fr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. (FR)',
      },
      confirmationSubmit: {
        en: 'Close this window',
        fr: 'Close this window (FR)'
      },
    },
  };

  return {
    getCopy: function (type, name) {
      try {
        if (type && name && langCode) {
          if (type !== 'global') {
            return data[type][name][langCode];
          } else {
            return globalLang[name][langCode];
          }
        }
      } catch (err) {
        console.log('Error: ' + type + ', ' + name + ', ' + langCode + ' not found in getCopy in languageController');
      }
    },
    getError: function (type) {
      try {
        if (type && langCode) {
          return errorLang[type][langCode];
        }
      } catch (err) {
        console.log('Error: Error message of ' + type + ', ' + langCode + ' not found in getError in languageController');
      }
    },
    getFormCopy: function (type, name) {
      try {
        if (type && name, langCode) {
          return formLang[type][name][langCode];
        }
      } catch (err) {
        console.log('Error: Form copy of ' + type + ', ' + name + ', ' + langCode + ' not found in getFormCopy in languageController');
      }
    }
  };
})();
